<template>
  <v-container
    grid-list-xl
    fluid
  >
    <LoadingState
      v-if="loading"
      :loading="loading"
      color="primary"
    />
    <v-layout
      v-else
      row
      wrap
    >
      <v-flex
        xs12
      >
        <v-alert
          :value="taxonomy.errors.length"
          type="error"
          icon="new_releases"
          dismissible
        >
          <div v-html="taxonomy.errorsText()"/>
        </v-alert>
      </v-flex>
      <v-flex
        v-if="!loading"
        xs12
      >
        <v-breadcrumbs
          v-if="taxonomyBreadcrumbs.length > 1"
          :items="taxonomyBreadcrumbs"
          divider=">"
        />

        <translations-tabs>
          <template #default="{language}">
            <TaxonomySingleName
              :taxonomy="taxonomy"
              :language="language"
            />
          </template>
        </translations-tabs>

        <TaxonomySingleSettings :taxonomy="taxonomy"/>

        <TaxonomySingleTreeRelations
          v-if="taxonomyItems.length"
          :taxonomy="taxonomy"
          :taxonomy-items="taxonomyItems"
        />

        <TaxonomySingleProducts
          :taxonomy="taxonomy"
        />
        <v-divider />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import TaxonomySingleName from './TaxonomySingleName'
import TaxonomySingleProducts from './TaxonomySingleProducts'
import TaxonomySingleTreeRelations from './TaxonomySingleTreeRelations'
import ProductService from '@/modules/Products/service.js'
import LoadingState from '@/components/LoadingState'
import TranslationsTabs from '@/components/widgets/TranslationsTabs'
import TaxonomySingleSettings from '@/modules/Products/components/TaxonomySingle/TaxonomySingleSettings'

export default {
  name: 'TaxonomySingle',
  components: {
    TaxonomySingleSettings,
    TranslationsTabs,
    TaxonomySingleName,
    TaxonomySingleProducts,
    TaxonomySingleTreeRelations,
    LoadingState
  },

  props: {
    taxonomy: {
      type: Object,
      required: true
    },
    taxonomyBreadcrumbs: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      taxonomyItems: [],
      servicesLoaded: false
    }
  },

  computed: {
    loading () {
      return Object.entries(this.taxonomy).length === 0 || !this.servicesLoaded
    }
  },

  async created () {
    this.taxonomyItems = await ProductService.loadTaxonomy({ sortBy: 'name', rowsPerPage: -1 })
    this.servicesLoaded = true
  }
}
</script>
